<template>
    <div>
        <div v-if="isOtherHeader">
            <HeaderTop />
            <HeaderBottom :themeConfig="themeConfig" />
            <!-- <HeaderBottom :show-slogan="fromTemplateId === 2" :class="{ 'xj-header-bottom-container': fromTemplateId === 4, 'gz-header-bottom-container': fromTemplateId === 5 }"/> -->
            <HeaderMenu cur-tab="home" />
        </div>
        <!-- 通用头部 -->
        <HeaderMenu v-else class="common-header-menu" cur-tab="common-main" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import HeaderTop from '@/components/header/home-header.vue';
import HeaderBottom from './part/header/header-bottom.vue';
import HeaderMenu from '@/components/menu/index.vue';

const props = defineProps({
    fromTemplateId: {
        // 模板：2-西城 4-新疆 5-贵州
        type: [Number, String],
        default: '',
    },
    themeConfig: {
        type: Object,
        default: () => {
            return {};
        },
    },
});

// 其他自定义头部
const isOtherHeader = computed(() => {
    return [2, 4, 5].includes(+props.fromTemplateId);
});
</script>

<style>
.common-header-menu {
    top: 0;
}
</style>
